import { z } from 'zod';

export const step1Schema = z.object({
  full_name: z.string().trim().min(2, 'Name must be at least 2 characters').max(100, 'Name must be less than 100 characters'),
  email: z.string().trim().email('Please enter a valid email').max(255, 'Email must be less than 255 characters'),
  phone: z.string().trim().min(10, 'Please enter a valid phone number').max(20, 'Phone number is too long'),
});

export const step2Schema = z.object({
  organization_type: z.string().min(1, 'Please select an organization type'),
  organization_name: z.string().trim().min(2, 'Organization name must be at least 2 characters').max(200, 'Organization name is too long'),
  role_title: z.string().min(1, 'Please select your role'),
});

export const step3Schema = z.object({
  services_interested: z.array(z.string()).min(1, 'Please select at least one service'),
  primary_objective: z.string().min(1, 'Please select a primary objective'),
  referral_source: z.string().min(1, 'Please tell us how you heard about us'),
});

export const step4Schema = z.object({
  geographic_focus: z.string().min(1, 'Please select a geographic focus'),
  target_audience: z.string().trim().min(10, 'Please describe your target audience (at least 10 characters)').or(z.literal('Will discuss')),
  budget_range: z.string().min(1, 'Please select a budget range'),
  timeline: z.string().min(1, 'Please select a timeline'),
  additional_notes: z.string().max(2000, 'Notes must be less than 2000 characters').optional(),
});

export type Step1Data = z.infer<typeof step1Schema>;
export type Step2Data = z.infer<typeof step2Schema>;
export type Step3Data = z.infer<typeof step3Schema>;
export type Step4Data = z.infer<typeof step4Schema>;
